/**
 * Status einer Geburtstagsbuchung
 */
export enum HolidayProgramBookingStatus {
   /**
    * Buchungsanfrage vom Kunden erhalten, aber noch nicht bestätigt.
    */
   pending = "pending",

   /**
    * Buchung ist auf Warteliste.
    */
   waitingList = "waitingList",

   /**
    * Buchung ist vollständig, Ferienbetreuung kann stattfinden.
    */
   booked = "booked",

   /**
    * Ferienbetreuung durchgeführt, Rechnung kann gestellt werden.
    */
   readyForPayment = "readyForPayment",

   /**
    * Rechnung wurde exportiert. Jetzt ist nichts mehr zu tun.
    */
   paymentExported = "paymentExported",

   /**
    * Buchung wurde storniert, Rechnung fuer Stornierungsgebuehr kann gestellt werden.
    */
   canceled = "canceled",

   /**
    * Buchung wurde storniert und Stornierungsgebuehr wurde exportiert.
    */
   cancellationFeeExported = "cancellationFeeExported"
}